import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { VscEye } from 'react-icons/vsc';
import logo from '../img/logos/kisaankhatalogo.png';
import Loader from '../common/Loader';
import { useDispatch } from 'react-redux';
import { SendOtp, VerifyOtpUpdatePassword } from '../store/slices/auth';

const ForgotPassword = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [alertEmail, setAlertEmail] = useState('');
  const [alertOtp, setAlertOtp] = useState('');
  const [alertNewPassword, setAlertNewPassword] = useState('');
  const [alertConfirmPassword, setAlertConfirmPassword] = useState('');
  const [passwordShown, setPasswordShown] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };

  const validateEmail = (value) => {
    const regEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regEmail.test(value)) {
      setAlertEmail('Please enter a valid email');
      return false;
    }
    setAlertEmail('');
    return true;
  };

  const validateOtp = (value) => {
    const otpValue = value.trim();
    if (!/^\d{6}$/.test(otpValue)) {
      setAlertOtp('Please enter a 6 digit OTP');
      return false;
    }
    setAlertOtp('');
    return true;
  };

  const validatePasswords = () => {
    let isValid = true;

    if (newPassword.length < 6) {
      setAlertNewPassword('Password must be at least 6 characters long.');
      isValid = false;
    } else {
      setAlertNewPassword('');
    }

    if (newPassword !== confirmPassword) {
      setAlertConfirmPassword('Passwords do not match.');
      isValid = false;
    } else {
      setAlertConfirmPassword('');
    }

    return isValid;
  };

  const handleSendOtp = async (e) => {
    e.preventDefault();
    if (!validateEmail(email)) return;

    try {
      setIsLoading(true);
      const data = await dispatch(SendOtp({ email })).unwrap();
      setStep(2);
      toast.success(data?.user?.message || 'OTP sent to your email.');
    } catch (error) {
      toast.error(error?.message || 'Failed to send OTP. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (!validateOtp(otp) || !validatePasswords()) return;

    try {
      setIsLoading(true);
      const data = await dispatch(
        VerifyOtpUpdatePassword({
          email,
          otp,
          password: newPassword,
        })
      ).unwrap();
      toast.success(data?.user?.message || 'Password updated successfully. Please login.');
      navigate('/login');
    } catch (error) {
      toast.error(error?.message || 'Failed to update password. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      {isLoading && <Loader isLogin={true} />}
      <section className="login-bg-image">
        <div className="bg-overlay-orange"></div>
        <div className="card-section">
          <div className="d-flex justify-content-evenly align-items-center" style={{ justifyContent: 'space-evenly' }}>
            <img src={logo} alt="travel-logo" className="div-logo" />
            <div className="h-logn-line" />

            <div className="login-form-2">
              <div className="d-flex justify-content-center">
                <img src={logo} alt="logo" className="logo-form-2" />
              </div>
              <h2 className="text-start mb-4" style={{ color: 'black', fontWeight: '500' }}>
                {step === 1 ? 'Forgot Password' : 'Verify OTP'}
              </h2>

              {step === 1 && (
                <form onSubmit={handleSendOtp}>
                  <input
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      validateEmail(e.target.value);
                    }}
                    className="form-control text-black-ph"
                    placeholder="User Email"
                    style={{ height: '50px' }}
                  />
                  <p className="alert-message">{alertEmail}</p>

                  <div className="col-md-12 d-flex justify-content-center mt-4">
                    <button type="submit" className="btn btn-warning login-btn col-white">
                      Send OTP
                    </button>
                  </div>
                  <hr />
                  <p className="text-start">
                    <Link to="/login" className="heightlight-black text-center">
                      Back to login
                    </Link>
                  </p>
                </form>
              )}

              {step === 2 && (
                <form onSubmit={handleResetPassword}>
                  <input
                    value={otp}
                    onChange={(e) => {
                      setOtp(e.target.value);
                      validateOtp(e.target.value);
                    }}
                    className="form-control text-black-ph"
                    placeholder="Enter OTP"
                    style={{ height: '50px' }}
                  />
                  <p className="alert-message">{alertOtp}</p>

                  <div className="position-r mt-2">
                    <input
                      type={passwordShown ? 'text' : 'password'}
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      className="form-control text-black-ph"
                      placeholder="New Password"
                      style={{ height: '50px' }}
                    />
                    <VscEye className="eye_icon_login" onClick={togglePassword} />
                  </div>
                  {alertNewPassword && <p className="alert-message">{alertNewPassword}</p>}

                  <div className="position-r mt-4">
                    <input
                      type={passwordShown ? 'text' : 'password'}
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      className="form-control text-black-ph"
                      placeholder="Confirm Password"
                      style={{ height: '50px' }}
                    />
                    <VscEye className="eye_icon_login" onClick={togglePassword} />
                  </div>
                  {alertConfirmPassword && <p className="alert-message">{alertConfirmPassword}</p>}

                  <div className="col-md-12 d-flex justify-content-center mt-4">
                    <button type="submit" className="btn btn-warning login-btn col-white">
                      Update Password
                    </button>
                  </div>
                  <hr />
                  <p className="text-start">
                    <Link to="/login" className="heightlight-black text-center">
                      Back to login
                    </Link>
                  </p>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ForgotPassword;
